<template>
  <PageHeader>
    <template #header-title>
      {{ $t('Your projects') }}
    </template>
    <template #header-actions>
      <div v-if="user.hasPermission('create-projects')" class="tw-text-end">
        <div class="btn-group">
          <WdsButton primary @click="showNewProject = true">
            {{ $t('Add project') }}
          </WdsButton>
        </div>
      </div>
    </template>
    <template #header-description>
      {{ $t('Add your projects to your Worksome account') }}
    </template>
  </PageHeader>
  <CompanyProjects />
  <ModalNewProject
    :account-id="accountId"
    :show="showNewProject"
    @cancel-create="close"
    @cancel="close"
  />
</template>

<script>
import { WdsButton } from '@worksome/wds-components'
import CompanyProjects from '@/components/Projects/CompanyProjects.vue'
import ModalNewProject from '@/components/Projects/ModalNewProject.vue'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import PageHeader from '@/components/PageHeader.vue'

export default {
  // eslint-disable-next-line vue/no-unused-components -- Baseline eslint ignore please fix if working on this
  components: {
    PageHeader,
    CompanyProjects,
    ModalNewProject,
    WdsButton,
  },
  data() {
    return {
      showNewProject: false,
    }
  },
  computed: {
    accountId() {
      return this?.account?.globalId
    },
  },
  mounted() {
    const url = new URL(window.location.href)
    if (url.searchParams.has('createProject')) {
      this.showNewProject = true
    }
  },
  methods: {
    $t,
    close() {
      this.showNewProject = false
    },
  },
}
</script>
